// E-mail domain helpers. Invitation links may be forwarded to colleagues on the same
// domain, so the domain - not the individual recipient - is what accepts the terms.

import { IRecipientsManagement } from "../models/IRecipientsManagement";

// An address without "@" is returned whole.
export const getEmailDomain = (email?: string): string => {
  const address = (email || "").trim().toLowerCase();
  return address.substring(address.lastIndexOf("@") + 1);
};

export const compareByEmailDomain = (
  a: { email?: string },
  b: { email?: string },
): number =>
  getEmailDomain(a.email).localeCompare(getEmailDomain(b.email), undefined, {
    sensitivity: "base",
  }) ||
  (a.email || "").localeCompare(b.email || "", undefined, {
    sensitivity: "base",
  });

export const getDomainAcceptance = (
  recipients?: IRecipientsManagement[],
): { accepted: number; total: number } => {
  const acceptedByDomain = new Map<string, boolean>();
  (recipients || []).forEach((recipient) => {
    const domain = getEmailDomain(recipient.email);
    if (recipient.isDeleted || !domain) return;
    const hasAccepted =
      recipient.termsConditionAccepted || !!recipient.acceptanceDate;
    acceptedByDomain.set(domain, acceptedByDomain.get(domain) || hasAccepted);
  });
  return {
    accepted: Array.from(acceptedByDomain.values()).filter(Boolean).length,
    total: acceptedByDomain.size,
  };
};
